import { FlexRowAlignCenter } from "@/components/Flex";
import LinkWrapper from "@/components/wrappers/Link";
import { spacing } from "@/utils/spacing";
import { Attachment } from "@knowt/syncing/graphql/schema";
import { Paperclip } from "lucide-react";
import { capitalize } from "@knowt/syncing/utils/stringUtils";

const CashedMessageAttachmentCard = ({
    attachment,
    attachmentTagStyle,
}: {
    attachment: Attachment;
    attachmentTagStyle?: React.CSSProperties;
}) => {
    return (
        <LinkWrapper
            href={attachment.url}
            openInNewTab
            style={{
                gap: spacing.SM,
                padding: `${spacing.XS} ${spacing.SM}`,
                borderRadius: "1.2rem",
                ...attachmentTagStyle,
            }}>
            <FlexRowAlignCenter style={{ gap: spacing.XS }}>
                <Paperclip size={18} />
                {capitalize(attachment.type)}
            </FlexRowAlignCenter>
        </LinkWrapper>
    );
};

export default CashedMessageAttachmentCard;
